import React from 'react';

const Contactos = () => {
  return (
    <div className="container mt-5">
      <div className="text-center mb-5">
        <img 
          src="/ubicacion.JPG" 
          className="img-fluid rounded shadow-lg" 
          alt="Granja" 
          style={{ width: "100%", height: "auto", maxWidth: "600px", objectFit: "contain", margin: "60px auto" }} 
        />
      </div>
      
      <div className="card text-center shadow-lg border-0" style={{ margin: "20px", backgroundColor: "#f8f9fa" }}>
        <div className="card-body p-4">
          <h3 className="mt-4 text-success">Ubicación:</h3>
          <p className="fs-5">Zona norte de Cartagena, km 18 vía Cartagena - Barranquilla, en el corregimiento de Arroyo de Piedra.</p>
          <div className="map-responsive my-3">
            <iframe
              title="Mapa de la Granja"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125678.456789!2d-75.514345!3d10.400000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef42d9a4a4c5b3d%3A0x0!2sArroyo%20de%20Piedra!5e0!3m2!1sen!2sco!4v1641323456789"
              width="100%" height="300" style={{border:0, borderRadius: "10px"}} allowFullScreen="" loading="lazy"></iframe>
          </div>
          <hr />
          <h3 className="mt-4 text-success">Contactos:</h3>
          <p className="fs-5">Instagram: <a href="https://www.instagram.com/casaorigenecohotel?igsh=MWk1NTlrcXZtd2w4Yg==" target="_blank" rel="noopener noreferrer" className="text-decoration-none">@casaorigenecohotel</a></p>
          <p className="fs-5">Teléfono: <a href="tel:+573188959559" className="text-decoration-none">+57 318 895 9559</a></p>
        </div>
      </div>
    </div>
  );
};

export default Contactos;